import Lottie from 'lottie-react'
import styled from 'styled-components'
import { MAIN_COLORS } from '../../consts/colors'
import { memo, ReactNode } from 'react'


const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    border-radius: 14px;
    background: ${MAIN_COLORS.gradient_yellow_pink};
    height: 25vw;
    overflow: hidden;

    .anim {
        width:50vw;
        height:50vw;
        svg {
            transform: translate(10%, -15%) !important;
        }
    }
`
const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: flex-start;
    padding: 12px;

    h3 {
        color: ${MAIN_COLORS.purple_100};
    }

    button {
        width: 80%;
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
        padding: 6px;
        background: ${MAIN_COLORS.purple_200};
        color:#ffffff;
        border: none;
        border-radius: 4px;
    }
`
const GifCard = ({ gif, button, text, onClick }: { gif: unknown, button: ReactNode | string | null, text: string, onClick?: () => void }) => {

  return (
    <Wrapper onClick={onClick}>
        <Column>
            <h3>{text}</h3>
            {button && <button>{button}</button>}
        </Column>
      <Lottie className="anim" animationData={gif}/>
    </Wrapper>
  )
}

export default memo(GifCard)
